import { useParams } from "react-router-dom";
import { ServiceDetailTemplate } from "@/components/detail/ServiceDetailTemplate";
import { getServiceDetail } from "@/data/serviceDetails";
import NotFound from "@/pages/NotFound";

export default function ServiceDetail() {
  const { slug } = useParams();
  const data = getServiceDetail(slug);
  if (!data) return <NotFound />;
  return <ServiceDetailTemplate data={data} key={slug} />;
}
